import moment from "moment";
import CheckNewOrders from "../symbols/checkNewOrdersArchived";

const initialState = {
  data: false,
  loading: false,
  error: false,
  timeStamp: moment().utc().format(),
};

export default function CheckNewOrdersArchivedReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case CheckNewOrders.CHECK_NEW_ORDERS_ARCHIVED:
      return { ...state, loading: true, error: false };
    case CheckNewOrders.CHECK_NEW_ORDERS_ARCHIVED_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
        timeStamp: moment().utc().format(),
      };
    case CheckNewOrders.CHECK_NEW_ORDERS_ARCHIVED_FAILURE:
      return {
        ...state,
        data: false,
        loading: false,
        error: true,
      };
    case CheckNewOrders.CLEAR_CHECK_NEW_ORDERS_ARCHIVED:
      return {
        ...state,
        data: false,
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
